<template>
  <v-popover v-if="text" trigger="hover" placement="top" delay="0" style="display: flex;">
    <div slot="popover" class="popoverClasses">
      <div v-if="!isOverFontNumble" v-html="text"></div>
      <div v-else >
        <div>
          <span>{{ $t('please_download_and_view请下载后查看') }}：</span>
          <a-button type="primary" @click="download" class="btn_downLoad">{{ $t('common_download') }}</a-button>
        </div>
      </div>
    </div>
    <span class="base_span" v-html="text"></span>
  </v-popover>
  <div v-else>无修改</div>
</template>
<script>
import { QueryDownload } from '@/api/login'

export default {
  props: {
    record: Object
  },
  computed: {
    isOverFontNumble () {
      var chineseStrLength = `${this.text || ''}`.length
      if (chineseStrLength > 1000) {
        return true
      } else {
        return false
      }
    },
    text () {
      const { record: { detail, optContents, optContext } } = this
      let text = ''
      if (optContents) {
        return optContents.join(',')
      } else if (optContext) {
        return optContext
      }
      for (let item of (detail || [])) {
        if (item.detail) {
          text += `${item.title}：${item.detail}<br>`
        } else {
          text += `${item.title}：${item.oldContent} => ${item.newContent}<br>`
        }
      }
      return text
    }
  },
  methods: {
    getPopupContainer () {
      return this.$parent.$el
    },
    download () {
      const { record } = this
      QueryDownload({ id: record.id }).then(res => {
        console.log(res)
        this.fileDownload(res.data.afterContent, this.$t('developer_operation_content'))
      })
    },
    async fileDownload (content, name = '操作内容', suffix = 'docx') {
      try {
        const data = await `\uFEFF${content}`
        const blob = new Blob([data], { type: 'docx,charset=UTF-8' })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = `${name}.${suffix}`
        document.body.appendChild(downloadElement)
        downloadElement.click()
        this.$notification.success({
          message: this.$t('developer_download_successful')
        })
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      } catch (e) {
        this.$notification.error({
          message: typeof e === 'string' ? e : JSON.stringify(e)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.base_span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-all;
}

.btn_downLoad {
  width: auto;
  height: 22px;
  background: #077BFC;;
  border-radius: 4px;
}
.popoverClasses {
  max-width: 70vh;
  max-height: 20vh;
  overflow: auto;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  // background: rgba(0,0,0,0.85);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  opacity: 0.95;
  border-radius: 4px;
  // padding: 12px 16px;
  &::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
    // border: 2px #fff solid;
  }
}
</style>
